import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface SettingsOptionTileProps {
  label: string;
  selected?: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

export function SettingsOptionTile({
  label,
  selected,
  onClick,
  children,
  className,
}: SettingsOptionTileProps) {
  return (
    <button
      type="button"
      className={cn('settings-option-tile', selected && 'is-selected', className)}
      aria-pressed={selected}
      onClick={onClick}
    >
      <span className="settings-option-tile__icon">{children}</span>
      <span className="settings-option-tile__label">{label}</span>
    </button>
  );
}

interface SettingsSectionProps {
  title: string;
  children: ReactNode;
}

export function SettingsSection({ title, children }: SettingsSectionProps) {
  return (
    <section className="settings-section">
      <h3 className="settings-section__title">{title}</h3>
      {children}
    </section>
  );
}
